<template>
  <svg xmlns="http://www.w3.org/2000/svg" v-on="$listeners" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M4 19v1h18v2H2V2h2v15c3 0 6-2 8.1-5.6c3-5 6.3-7.4 9.9-7.4v2c-2.8 0-5.5 2.1-8.1 6.5C11.3 16.6 7.7 19 4 19Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'chart-area',
}
</script>
